export default __webpack_public_path__ + "static/media/evento-6.d97c1b9a.jpg";